<!-- eslint-disable max-len -->
<template>
  <aha-modal @hide="hide()" :title="getModalTitle">
    <div v-if="isCreateFromPresenter">
      <div class="tab-content">
        <p>
          {{ $i18nPresenter.t("Removing this member will revoke their access to team presentations.") }}
        </p>
      </div>
    </div>
    <div v-else>
      <div class="tab-content">
        <p>
          {{ $i18nPresenter.t("Removing") }} <b>{{ member.firstName + ' ' + member.lastName + ' ('+ member.email + ')' }}</b>
          {{ $i18nPresenter.t("from your team will:") }}
        </p>
        <ul class="ul">
          <li>
            {{ $i18nPresenter.t("Free up 1 licence.") }}
          </li>
          <li>
            {{ $i18nPresenter.t("Revert their plan to Free.") }}
          </li>
          <li>
            {{ $i18nPresenter.t("They will lose access to the team presentations.") }}
          </li>
          <li>
            {{ $i18nPresenter.t("Presentations & folders created by this member will be transferred to the team owner.") }}
          </li>
        </ul>
      </div>
    </div>
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isRemovingMember"
        @click="handleRemoveAccountFromTeam()"
        icon-name="delete"
        :submitting="isRemovingMember"
        has-margin-right
      >
        <aha-spinner variant="white" class="mr-1" v-if="isRemovingMember" />
        {{ $i18nPresenter.t("Remove") }}
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>

// constants
import eventCategories from '@/constant/eventCategories'

import Util from '@/util'
import AccountApi from '@/api/account'

export default {
  props: {
    member: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isRemovingMember: false,
      modalContent: '',
    }
  },
  computed: {
    isCreateFromPresenter() {
      return this.$store.state.currentAccount.createdFrom === 'presenter'
    },
    getModalTitle() {
      return this.$i18nPresenter.t('Are you sure you want to remove {firstName} from your team?', { firstName: this.member.firstName })
    },
  },
  created() {

  },
  mounted() {
  },

  methods: {
    async handleRemoveAccountFromTeam() {
      this.isRemovingMember = true
      try {
        await AccountApi.deleteAccount(this.member.id)
        Util.mixpanelTracking(
          eventCategories.MY_TEAM,
          'Team management > Remove member from team > Removed successfully',
        )
        this.$emit('getTeamMember')
        this.$emit('hide')
        Util.showToastSuccess(`${this.$i18nPresenter.t('Removed email:')} "${this.member.email}"`)
      } catch (error) {
        Util.mixpanelTracking(
          eventCategories.MY_TEAM,
          'Team management > Remove member from team > Remove failed',
        )
        Util.showToastError(`${this.$i18nPresenter.t('Removed email:')} "${this.member.email}" failed`)
        throw new Error('My Team > Get account by ID failed.')
      } finally {
        this.isRemovingMember = false
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style scoped lang="scss">
.tab-content {
  .ul {
    list-style: disc !important;
    padding-left: 1.25rem !important;
  }
}
</style>
